import React, { Component } from 'react'
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import { withRouter } from "react-router-dom";
import moment from 'moment'
import config from 'react-global-configuration';

class InvoiceTable extends Component {

  constructor(props) {
      super(props)
      this.state = {
          data: this.props.data,
      }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data)
      this.setState({ data: this.props.data })
  }

  sortDates = (a, b, order) => {
    let indices = [6, 7, 8, 9, 3, 4, 0, 1];
    if (order === 'asc') {
      let r = 0;
      indices.find(i => r = a.date.charCodeAt(i) - b.date.charCodeAt(i));
      return r;
    } else if (order === 'desc') {
      let r = 0;
      indices.find(i => r = b.date.toString().charCodeAt(i) - a.date.toString().charCodeAt(i));
      return r;
    }
  }

  onRowClick = row => {
    if(this.props.onRowClick === "details")
      this.props.history.push(`/internal/admin/applications/${row.objectId}`);
  }

  render() {
    const applications = this.state.data;
    const hidden = this.props.hide ? this.props.hide : [];

    if(!(applications != null && applications.length > 0))
      return <p style={{color: "#000000"}}>Keine Bewerbungen</p>

    let applicationItems = []

    applications.map((app, idx) =>
      applicationItems.push({
        objectId: app.objectId,
        date: moment(app.createdAt).locale("en").format('DD/MM/YYYY'),
        golfcourse: app.golfcourse,
        knownMember: app.knownMember,
        name: app.title + " " + app.firstname + " " + app.lastname,
        position: app.position,
        phone: app.phone,
        company: app.company,
        email: app.email
      })
    )

    return (
      <div>
        <BootstrapTable data={ applicationItems } borderless={true} options={{ onRowClick: this.onRowClick, defaultSortName: 'date', defaultSortOrder: 'desc' }} hover={true} pagination={this.props.pagination} search={this.props.search}>
          <TableHeaderColumn dataField="objectId" isKey>ID</TableHeaderColumn>
          <TableHeaderColumn dataField="date" dataSort={true} sortFunc={this.sortDates}>beworben am</TableHeaderColumn>
          <TableHeaderColumn dataField="golfcourse">Golfclub</TableHeaderColumn>
          <TableHeaderColumn dataField="knownMember" dataSort={true}>Bekanntes Mitglied</TableHeaderColumn>
          <TableHeaderColumn dataField="name" dataSort={true}>Name</TableHeaderColumn>
          <TableHeaderColumn dataField="company">Firma</TableHeaderColumn>
          <TableHeaderColumn dataField="position">Position</TableHeaderColumn>
          <TableHeaderColumn dataField="phone">Telefonnummer</TableHeaderColumn>
          <TableHeaderColumn dataField="email">E-Mail</TableHeaderColumn>
        </BootstrapTable>
      </div>
    )
  }
}

export default withRouter(InvoiceTable)



// WEBPACK FOOTER //
// /src/components/Tables/ApplicationTable.js